import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { FileSourceEnum as x, FileSelectorModal as E, FileTypeEnum as g } from "@systemeio/file-manager";
import { Tooltip as v, toast as F } from "@systemeio/ui";
import { useEditorState as M } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as N, useMemo as y, Fragment as C } from "react";
import { ToolbarButton as b } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as p, TOOLTIP_STYLES as O } from "../../constants/default-styles.mjs";
import { ImageModeEnum as k } from "./image-enum.mjs";
import I from "../../icons/image-icon.mjs";
import { InsertImageViaLink as h } from "./insert-image-via-link.mjs";
import { useTranslation as B } from "../../i18n.mjs";
import { ImageBubbleMenu as L } from "./image-bubble-menu.mjs";
const G = (a, t) => {
  const { t: n } = B(), s = (t == null ? void 0 : t.fileSource) ?? x.TextEditor, [u, m] = N(!1), d = M({
    editor: a,
    selector: ({ editor: r }) => ({
      isEditable: (r == null ? void 0 : r.options.editable) ?? !1
    })
  }), e = !(d != null && d.isEditable);
  return y(() => {
    const r = (i) => {
      if (!a) return null;
      const f = () => a.chain().focus().run();
      if (!i) return f();
      const l = new Image();
      l.src = i, l.onerror = () => {
        F.error(n("image_error")), f();
      }, l.onload = () => {
        const S = l.naturalWidth, T = l.naturalHeight;
        a.chain().focus().setImage({
          src: i,
          imageMode: k.BlockCenter,
          containerWidth: "auto",
          width: S,
          height: T
        }).run(), m(!1);
      };
    };
    return {
      toolbarRender: /* @__PURE__ */ c("div", { className: "hover:divide-text-secondary/30 flex divide-x divide-transparent", children: [
        /* @__PURE__ */ o(v, { disabled: e, label: n("image"), ...O, children: /* @__PURE__ */ o(b, { disabled: e, onClick: () => m(!0), children: /* @__PURE__ */ o(I, { className: p(e) }) }) }),
        /* @__PURE__ */ o(h, { handleSetImage: r, isDisabled: e })
      ] }),
      tooltipRender: /* @__PURE__ */ c("div", { className: "divide-text-secondary/30 flex divide-x", children: [
        /* @__PURE__ */ c(
          b,
          {
            className: "gap-1.5",
            disabled: e,
            onClick: () => m(!0),
            children: [
              /* @__PURE__ */ o(I, { className: p(e) }),
              n("image")
            ]
          }
        ),
        /* @__PURE__ */ o(h, { handleSetImage: r, isDisabled: e })
      ] }),
      additionalRender: /* @__PURE__ */ c(C, { children: [
        /* @__PURE__ */ o(
          E,
          {
            initialSearchFilters: {
              name: "",
              source: [s],
              type: [g.Image, g.ImageOther]
            },
            opened: u,
            onClose: () => m(!1),
            onSelect: ({ path: i }) => r(i),
            uploadingFromSource: s,
            disabledFileTypeSelect: !0
          }
        ),
        /* @__PURE__ */ o(L, { editor: a, fileSource: s, options: t })
      ] })
    };
  }, [e, u, a, s, t, n]);
};
export {
  G as useImageExtensionToolbar
};
